<template>
  <div class="el-main" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="loadingText">
    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>学歴を入力</h2>
          <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear" :month="basicData.birthMonth"
                :day="basicData.birthDay"></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                  @click="$modal.show('educational-reset')">リセット</el-button>
              </div>
              <modal name="educational-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('educational-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">学歴リセット</div>
                <span>入力されている学歴をすべて削除します。よろしいですか？</span>

                <div class="text-left">
                  <el-button type="primary"
                    @click="$modal.hide('educational-reset'); resetEducationalBackgrounds()">リセットする</el-button>
                  <el-button @click="$modal.hide('educational-reset')">リセットしない</el-button>
                </div>
              </modal>

            </div>
          </div>

          <div class="edit-form-item" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
            <div class="item-name">卒業予定</div>
            <div class="item-body">
              <el-select v-model="formatData.gradeYear" placeholder="選択してください">
                <el-option v-for="item in gradeYearOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory" v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories" @click.native="activateHistoryItem(item.uuid)"
                :item="item" :length="formatData.educationalHistories.length" :index="index" :key="item.uuid"
                :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }" :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index" :createDate="formatData.createDate"
                :descriptionPlaceholder="'学歴を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addEducationalHistory()"></el-button>
            </div>
          </div>
          <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>

        <div v-if="formatId == 'rirekisho_job_change_old'">
          <p class="guidetxt">学歴の見本（参考にして作成しましょう）</p>
          <img src="/static/img/rirekishoguide/guide03.png" alt="学歴" class="guideimg">
        </div>

      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職歴を入力</h2>
          <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
          <p v-if="formatId == 'rirekisho_hukugyo'">会社名を書きたくない場合は、「XX業界でのXX職」と書きましょう。</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
              <auto-job-histories v-on:job-histories-created="setJobHistories" :birth-year="basicData.birthYear"
                :birth-month="basicData.birthMonth" :birth-day="basicData.birthDay"></auto-job-histories>
              <div class="button-reset">
                <el-button type="" v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                  @click="$modal.show('job-reset')">リセット</el-button>
              </div>
              <modal name="job-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('job-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">職歴リセット</div>
                <span>現在入力されている職歴をすべて削除します。よろしいですか？</span>
                <div>
                  <el-button type="primary" @click="$modal.hide('job-reset'); resetJobHistories()">リセットする</el-button>
                  <el-button @click="$modal.hide('job-reset')">リセットしない</el-button>
                </div>
              </modal>
            </div>

            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addJobHistory" v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory" v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.jobHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'職歴を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>

            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addJobHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
              <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
            </div>

            <div v-if="formatId == 'rirekisho_job_change_old'">
              <p class="guidetxt">職歴の見本（参考にして作成しましょう）</p>
              <img src="/static/img/rirekishoguide/guide04.png" alt="職歴" class="guideimg">
            </div>

            <div class="tips" v-if="formatId == 'rirekisho_job_change_old'">
              <details class="tips__accordion">
                <summary>履歴書の書き方ガイド</summary>
                <p><span style="font-weight: bold; color: #004D40;">① シンプルに書く</span><br>
                  基本的に雇用形態や職種、配属先などは記入不要です。職歴の具体的な成果は職務経歴書に記載し、履歴書はシンプルで見やすく記入していくのがおすすめです。<br><br>
                  退職理由を書く時は「一身上の都合により退職」と書くのが一般的で、具体的な理由は書かなくても問題ありません。
                </p>
              </details>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>免許・資格を入力</h2>
          <p>主要な免許・資格は例文から選ぶことができます</p>
          <p v-if="formatId == 'rirekisho_job_change_old'">自動入力を使ってみましょう。主要な免許・資格は例文から選ぶことができます。<span
              style="color: #E3165C;">資格等が無い場合は「特になし」と記載し、空白を避けましょう。</span></p>
          <el-checkbox v-model="formatData.notDisplayIjyoLicense">【以上】を表示しない</el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog');" type="success">例文から追加</el-button>
            <modal name="license-dialog" :adaptive="true" :scrollable="true" height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('license-dialog');" icon="el-icon-close" type="text"></el-button>
              </div>
              <div class="title">例文を選ぶ</div>
              <div class="description">
                <p>選択した例文が追加されます。</p>
              </div>
              <ul class="example-sentence">
                <li v-for="(item, idx) in exampleSentences.license"
                  v-on:click="addLicenseHistory(null, { description: item.description }); $modal.hide('license-dialog');"
                  :key="idx">
                  <div class="title">{{ item.title }}</div>
                  <div class="body" v-html="item.description"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog');">閉じる</el-button>
              </div>
            </modal>
          </div>

          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addLicenseHistory" v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory" v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.licenseHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'免許・資格を入力'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addLicenseHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.licenseHistory">
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>

        <div v-if="formatId == 'rirekisho_job_change_old'">
          <p class="guidetxt">免許資格の見本（参考にして作成しましょう）</p>
          <img src="/static/img/rirekishoguide/guide05.png" alt="免許・資格" class="guideimg">
        </div>
      </div>
    </div>

    <div class="card" v-if="currentCardId == 'reason'">
      <reason-card :format-id="formatId" :example-sentences="exampleSentences" :textarea-min-rows="textareaMinRows"
        :preview-errors="previewErrors" :format-data="formatData" @update:reason="value => formatData.reason = value"
        :current-card-id="currentCardId" />

      <div class="prime-tips-btn-wrap">
        <button class="prime-tips-btn" @click="$eventHub.$emit('open-ai-reason-dialog')">
          ヤギプライムで便利に使う
        </button>
      </div>

      <modal name="prime-reason-modal" :adaptive="true" :scrollable="true" height="auto" class="prime-modal">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('prime-reason-modal');" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="prime-modal-content">
          <div class="mypr-title-block">
            <p class="mypr-title-catch">ヤギプライム限定</p>
            <h3 class="prime-modal-title">ヤギプライムはメェっちゃ便利！</h3>
            <p class="prime-modal-lead">志望動機・自己PRでAI文章作成を使うと、<br>納得がいく自分だけの文章を作ることができます<br>その上、他にも便利な機能が！</p>
          </div>
          <div class="prime-modal-image">
            <img src="/static/renew2_img/prime-servicelist.png" alt="ヤギプライムサービス一覧">
          </div>
          <p class="prime-modal-note">※どのタイミングでも課金・退会していただくことが<br>できるので、安心してご利用いただけます。</p>
          <div class="prime-modal-buttons">
            <button class="prime-modal-cv-btn"
              @click="$modal.hide('prime-reason-modal'); handleYagiprimeRecommend()">ヤギプライムに加入する</button>
            <a href="/yagiprimeinfo" target="_blank" class="prime-modal-detail-btn">より詳しく説明を見る</a>
          </div>
        </div>
      </modal>
    </div>

    <div class="card" v-show="currentCardId == 'ai_reason'">
      <div class="container-base r-ai-format" v-if="!viewYagiprimepayment">
        <p class="r-midashi">ヤギプライム機能</p>
        <div class="title" v-if="!aiResultView">AIに自己PRと志望動機を書いてもらおう！</div>
        <div class="title" v-else>AIで自己PRと志望動機を提案</div>
        <div class="description" v-if="!aiResultView">
          <p>質問に答えるだけで、AIがあなたの自己PRと志望動機を作成してくれます。</p>
        </div>
        <div class="description" v-else>
          <p>AIから提案された文章をご活用ください。</p>
        </div>
        <div v-if="!aiResultView">
          <ul class="example-sentence">
            <li>
              <div class="title">※入力済みの履歴書内容
              </div>
              <div class="el-textarea">
                <div class="flex r-form-title">
                  <span>最終学歴</span>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="あなたの趣味" autocomplete="off"
                      v-model="formatData.lastestEdu"></el-input>
                  </div>
                </div>
                <div class="flex r-form-title">
                  <span>最終職歴</span>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="最終職歴" autocomplete="off"
                      v-model="formatData.lastestJob"></el-input>
                  </div>
                </div>
                <div class="flex r-form-title"><span>取得資格</span>
                  <div class="el-textarea">
                    {{ getLicences }}
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class=" title">Q.1 得意なこと
              </div>
              <div class="el-textarea">
                <div class="el-textarea"><el-input type="textarea" autosize placeholder="英語、プログラミング、コミュニケーション、Word　など"
                    title="あなたの趣味" autocomplete="off" v-model="formatData.ai_strength"></el-input></div>
              </div>
            </li>
            <li>
              <div class="title">Q.2 希望企業名</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-input type="textarea" autosize placeholder="株式会社Yagish　など" title="あなたの趣味"
                    autocomplete="off" v-model="formatData.ai_company_name"></el-input></div>
              </div>
            </li>
            <li>
              <div class="title">Q.3 希望業界</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-select v-model="formatData.hopeIndustrycategory" placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="(item, index) in hopeIndustryOptions" style="width: 100%;" :key="item"
                      :label="item" :style="item" :value="item"></el-option>
                  </el-select></div>
              </div>
            </li>
            <li>
              <div class="title">Q.4 希望職種</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-select v-model="formatData.hopeJobcategory" placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="(item, index) in hopeCareerJobcategoryOptions" style="width: 100%;" :key="item"
                      :label="item" :style="item" :value="item"></el-option>
                  </el-select></div>
              </div>
            </li>
          </ul>
          <div class="text-center r-btn-wrap">
            <el-button type="button" @click="getAIMypr()" class="r-ai-btn">この内容でAI自己PRを作成</el-button>
          </div>
        </div>
        <div v-else>
          <ul class="example-sentence">
            <li>
              <div class="title">AIから自己PRの提案</div>
              <div class="body" v-html="aiResultMyprResult"></div>
              <button v-on:click="formatData.reason = aiResultMyprResult.replace(/<br>/ig, '\n') + '\n';" style="background: #f56c6c;border-radius: 5px;color: #fff;font-weight: bold;width: 100%;padding: 10px
                0;margin: 10px 0 20px;"><span>この自己PRを使う</span></button>
            </li>
            <li>
              <div class="title">AIから志望動機の提案</div>
              <div class="body" v-html="aiResultReasonResult"></div>
              <button v-on:click="formatData.reason = aiResultReasonResult.replace(/<br>/ig, '\n') + '\n';" style="background: #f56c6c;border-radius: 5px;color: #fff;font-weight: bold;width: 100%;padding: 10px
                0;margin: 10px 0 20px;"><span>この志望動機を使う</span></button>
            </li>
          </ul>
          <div class="text-center r-btn-wrap" v-if="$globalVar.isYagiPrime">
            <el-button type="button" v-on:click="aiResultView = false" class="r-ai-btn">再度取得する</el-button>
          </div>
          <div class="text-center r-btn-wrap" v-else>
            <el-button v-if="$globalVar.in_app_payments" type="button" @click="viewPaymentYagiprime"
              class="r-ai-btn">ヤギプライムに加入して<br>文章全体を取得する</el-button>
          </div>
          <br>
          <div class="title" style="text-align: center;" v-if="!$globalVar.isYagiPrime">
            AI履歴書はいかがでしたか？納得しなかった方はプロに見てもらいましょう！</div>
          <div class="text-center r-btn-wrap" v-if="!$globalVar.isYagiPrime">
            <el-button v-if="$globalVar.in_app_payments" type="button" @click="viewPaymentYagiprime"
              class="r-ai-btn">プロに相談する</el-button>
          </div>
        </div>
      </div>
      <div v-if="viewYagiprimepayment" class="ai-payment-card-box">
        <el-button v-ripple @click="$eventHub.$emit('go-card-to', 'output')" type="success" id="prime-payment-btn">
          AI志望動機を利用せず、<br>無料で履歴書作成をつづける <i class="el-icon-d-arrow-right"></i>
        </el-button>
        <div class="container-base r-ai-format">
          <div class="overflow-scroll-y" v-if="!completeBuyYagiprime">
            <YagiprimeWrapper />
          </div>
          <div class="overflow-scroll-y" v-else>
            <div class="card-header">
              <h2>ヤギプライムに登録</h2>
              <p>登録完了しました。</p>
              <p style="color:red;">※無料エージェント機能を使いますか？</p>
            </div>
            <div class="card-content" style="padding:0px;">
              <div class="edit-form-item">
                <div>
                  <div>
                    <div class="card">
                      <div class="overflow-scroll-y">
                        <div class="card-header">
                          <h2>担当エージェント会社の確認</h2>
                        </div>
                        <div class="card-content">
                          <div class="edit-form">
                            <div class="edit-form-item">
                              <div class="item-body" style="margin-left:10px;">
                                居住地：{{ basicData.address1 }}
                              </div>
                              <div class="item-body" style="margin-left:10px;">
                                希望職種：{{ formatData.hopeJobcategory }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-content">
                          <div class="edit-form" v-if="isMatching && false">
                            <div class="edit-form-item">
                              <div class="item-name">
                                <h3 class="h3">
                                  <span>会社名：{{ matchingCompany.company_name }}</span>
                                  <p>{{ matchingCompany.company_address1 }}</p>
                                  <img v-if="matchingCompany.company_logo" :src="matchingCompany.company_logo"
                                    style="width:50%" />
                                </h3>
                              </div>
                              <p style="font-size: 80%;">
                                Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
                                  target="_blank">利用規約</router-link>、<router-link id="footer-link-policy"
                                  :to="{ name: 'policyPage' }" target="_blank">個人情報保護方針</router-link>と
                                {{ matchingCompany.company_name }}の<a :href="matchingCompany.terms_url"
                                  target="_blank">利用規約</a>、<a :href="matchingCompany.privacy_url"
                                  target="_blank">個人情報保護方針</a>を確認して{{ matchingCompany.company_name }}に登録することになります。
                              </p>
                              <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img
                                  src="/static/renew_img/check_icon.png" alt="同意する" style="height: 30px;">
                                規約に同意する</p>
                            </div>
                            <div class="text-center r-btn-wrap">
                              <el-button type="button" @click="getAIMypr()" class="r-ai-btn">このエージェントにお願いする</el-button>
                            </div>
                          </div>
                          <div class="edit-form" v-else-if="isMatching">
                            <div class="yp-agent-register">
                              <div class="card-header">
                                <h2 class="yp-h2">もっとヤギプライムを活用するために</h2>
                                <p>特別に無料エージェント紹介を受けられます（Yagishと提携の会社による）。面接に進む等、最終的な判断はあなたに委ねられますのでご安心ください。</p>
                              </div>
                              <div class="card-content">
                                <div>
                                  <div>
                                    <p>居住地：{{ basicData.address1 }}</p>
                                    <p>希望職種：{{ formatData.hopeJobcategory }}</p>
                                  </div>
                                  <div class="yp-agent-list">

                                    <!--エージェントがある場合-->
                                    <div class="renew2_flex agent-info">
                                      <img v-if="matchingCompany.company_logo" :src="matchingCompany.company_logo"
                                        alt="該当エージェント" class="agent-logo">
                                      <div>
                                        <p class="agent-txt">会社名：{{ matchingCompany.company_name }}</p>
                                        <p class="agent-txt">{{ matchingCompany.company_address1 }}</p>
                                      </div>
                                    </div>

                                    <!--見つからない場合-->
                                    <!--<p class="yp-agent-lead">該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。</p>-->

                                    <p class="yp-agent-memo">Yagishの<a href="/terms" id="footer-link-terms"
                                        target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/"
                                        class="router-link-active" id="footer-link-policy" target="_blank">個人情報保護方針</a>と
                                      {{ matchingCompany.company_name }}の<a :href="matchingCompany.terms_url"
                                        target="_blank">利用規約</a>、<a :href="matchingCompany.privacy_url"
                                        target="_blank">個人情報保護方針</a>を確認して{{ matchingCompany.company_name }}に登録することになります。
                                    </p>
                                    <div class="flex consent-txt">
                                      <img src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック"
                                        class="consent-icon">
                                      <p>{{ matchingCompany.company_name }}の利用規約に同意する</p>
                                    </div>
                                  </div>
                                  <div class="flex consent-txt">
                                    <img src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック"
                                      class="consent-icon">
                                    <p>Yagishの利用規約に同意する</p>
                                  </div>
                                  <div class="text-center r-btn-wrap">
                                    <button type="button" @click="applyAgent()"
                                      class="el-button el-button--button r-ai-btn"><!----><!----><span>無料エージェントを希望する</span></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="edit-form" v-else>
                            <div class="yp-agent-register">
                              <div class="card-content">
                                <div>
                                  <div>
                                    <p>居住地：{{ basicData.address1 }}</p>
                                    <p>希望職種：{{ formatData.hopeJobcategory }}</p>
                                  </div>
                                  <div class="yp-agent-list">

                                    <!--見つからない場合-->
                                    <p class="yp-agent-lead">該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。</p>

                                  </div>
                                  <div class="flex consent-txt">
                                    <img src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック"
                                      class="consent-icon">
                                    <p>Yagishの利用規約に同意する</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="edit-form-item">
                              <p style="color:red;">該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。</p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-input type="textarea" v-model="formatData.reason"
        :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
      <div class="attention-limit character" v-if="previewErrors.reason">
        <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
      </div>

    </div>

    <div class="card" v-show="currentCardId == 'reasonNew'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自己PRを入力</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">例文から追加</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, idx) in exampleSentences.reason"
                v-on:click="formatData.reasonNew += item.description.replace(/<br>/ig, '\n') + '\n'; $modal.hide('reason-dialog')"
                :key="idx">
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reasonNew"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reasonNew">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>

          <div class="prime-tips-btn-wrap">
            <button class="prime-tips-btn" @click="$modal.show('prime-reasonnew-modal')">
              ヤギプライムで便利に使う
            </button>
          </div>

          <modal name="prime-reasonnew-modal" :adaptive="true" :scrollable="true" height="auto" class="prime-modal">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('prime-reasonnew-modal');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="prime-modal-content">
              <div class="mypr-title-block">
                <p class="mypr-title-catch">ヤギプライム限定</p>
                <h3 class="prime-modal-title">ヤギプライムはメェっちゃ便利！</h3>
                <p class="prime-modal-lead">志望動機・自己PRでAI文章作成を使うと、<br>納得がいく自分だけの文章を作ることができます<br>その上、他にも便利な機能が！</p>
              </div>
              <div class="prime-modal-image">
                <img src="/static/renew2_img/prime-servicelist.png" alt="ヤギプライムサービス一覧">
              </div>
              <p class="prime-modal-note">※どのタイミングでも課金・退会していただくことが<br>できるので、安心してご利用いただけます。</p>
              <div class="prime-modal-buttons">
                <button class="prime-modal-cv-btn"
                  @click="$modal.hide('prime-reasonnew-modal'); handleYagiprimeRecommend()">ヤギプライムに加入する</button>
                <a href="/yagiprimeinfo" target="_blank" class="prime-modal-detail-btn">より詳しく説明を見る</a>
              </div>
            </div>
          </modal>

        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'others'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>通勤時間ほか</h2>
          <p>通勤時間や扶養家族などを入力します</p>
          <p v-if="formatId == 'rirekisho_job_change_old'">（以下の見本も参考にし、わからない場合は空欄としておきましょう。）</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item" v-if="optionItems.commuteDescription & this.formatId != 'rirekisho_job_new'">
              <div class="item-name">通勤手段<small>（電車・バス・自家用車など）</small></div>
              <div class="item-body">
                <el-input class="input-md" type="textarea" placeholder="電車（JR◯◯線）"
                  v-model="formatData.commuteDescription" :autosize="{ minRows: 1, maxRows: 2 }">
                </el-input>
                <!--{{ $formLib.charCount(formatData.commuteDescription) }}-->
                <div class="error attention-limit character"
                  v-if="$formLib.charCount(formatData.commuteDescription) > 84">
                  <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。
                </div>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">通勤時間</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title="時間" type="number"
                  v-model="formatData.commuteHours"></el-input> 時間
                <el-input class="input-xs" type="number" placeholder="" title="分"
                  v-model="formatData.commuteMinutes"></el-input> 分
              </div>

              <div class="item-name">扶養家族（配偶者を除く）</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title="扶養家族の人数" type="number"
                  v-model="formatData.spouseNumber"></el-input> 人
              </div>
              <div class="item-name">配偶者</div>
              <div class="item-body">
                <el-radio v-model="formatData.hasSpouse" :label="true"> あり</el-radio>
                <el-radio v-model="formatData.hasSpouse" :label="false"> なし</el-radio>
              </div>
              <div class="item-name">配偶者の扶養義務</div>
              <div class="item-body">
                <el-radio v-model="formatData.underDutyToSupport" :label="true">あり</el-radio>
                <el-radio v-model="formatData.underDutyToSupport" :label="false">なし</el-radio>
              </div>
              <br>
              <div class="item-name" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                あなたは留学生ですか。</div>
              <div class="item-body" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                <el-radio v-model="formatData.foreignStudent" :label="true">はい</el-radio>
                <el-radio v-model="formatData.foreignStudent" :label="false">いいえ</el-radio>
              </div>
              <!--<el-checkbox v-model="formatData.notDisplayRecommend">紹介・推薦を表示しない</el-checkbox>-->
            </div>
          </div>
        </div>

        <div v-if="formatId == 'rirekisho_job_change_old'">
          <p class="guidetxt">見本（参考に作成しましょう）</p>
          <img src="/static/img/rirekishoguide/guide07.png" alt="通勤時間ほか" class="guideimg">
        </div>

      </div>
    </div>

    <div class="card" v-show="currentCardId == 'requests'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>本人希望欄を入力</h2>
          <p>給与・職種・勤務時間・勤務地などの希望を入力します（任意）</p>
          <p v-if="formatId == 'rirekisho_job_change_old'">ですが、<span
              style="color: #E3165C;">基本的には面接で話されることが多いため、「貴社規定に従います。」と記載しておくことが一般的</span>です。</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('request-dialog')" type="success">例文から追加</el-button>
        </div>

        <div class="card-content">

          <personal-request-fields
            mode="fields"
            :format-data="formatData"
            :basic-data="basicData"
            :format-id="formatId"
            :industry-data="industryData"
            :job-type-data="jobTypeData"
            :show-ai-card="true"
          />

          <modal name="request-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('request-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力している文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, idx) in exampleSentences.request"
                v-on:click="formatData.request += item.description.replace(/<br>/ig, '\n').replace('OOO', formatData.nowNensyu).replace('XXX', formatData.kibouNensyu) + '\n'; $modal.hide('request-dialog');"
                :key="idx">
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('request-dialog');">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }" placeholder="給与・職種・勤務時間・勤務地など希望があれば入力"
            v-model="formatData.request">
          </el-input>

          <personal-request-fields
            mode="ai-card"
            :format-data="formatData"
            :basic-data="basicData"
            :format-id="formatId"
            :industry-data="industryData"
            :job-type-data="jobTypeData"
            :show-ai-card="true"
            :request-ai-generated="requestAiGenerated"
            :request-ai-loading="requestAiLoading"
            :request-ai-error="requestAiError"
            :bizreach-industry-groups="bizreachIndustryGroups"
            :bizreach-job-category-groups="bizreachJobCategoryGroups"
            :get-industry-name="getIndustryName"
            :get-job-category-name="getJobCategoryName"
          />

          <div class="attention-limit character" v-if="previewErrors.request">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>

        <div v-if="formatId == 'rirekisho_job_change_old'">
          <p class="guidetxt">本人希望欄の見本（参考に作成しましょう）</p>
          <img src="/static/img/rirekishoguide/guide08.png" alt="本人希望欄" class="guideimg">
        </div>

      </div>
    </div>

    <div class="card" v-show="currentCardId == 'esf-detail'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>障がい情報入力</h2>
          <p> </p>
          <p style="color:red;"> </p>
        </div>
        <div class="card-content">

          <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の種類：</p>
          <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
            <el-select v-model="formatData.handbookKind" @change="selectHandbookKind" placeholder="選択してください">
              <el-option v-for="item in handbookKindOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <br />
          <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の障害種類：</p>
          <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
            <el-select v-model="formatData.shogaiKind" placeholder="選択してください">
              <el-option v-for="item in shogaiKindOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <br />
          <p v-if="formatData.shogaiKind == 'その他'" style="font-size: 90%;margin-bottom:5px;">手帳の障害種類の直接入力：</p>
          <div v-if="formatData.shogaiKind == 'その他'" style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.shogaiKind_etc"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>
          <br />
          <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の等級：</p>
          <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
            <el-select v-model="formatData.shogaiLevel" placeholder="選択してください">
              <el-option v-for="item in shogaiLevelOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <br />
          <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>通院の有無：</p>
          <div style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <el-radio v-model="formatData.hospitalVisit" label="あり"> あり</el-radio>
              <el-radio v-model="formatData.hospitalVisit" label="なし"> なし</el-radio>
            </p>
          </div>
          <br />
          <p v-if="formatData.hospitalVisit == 'あり'" style="font-size: 90%;margin-bottom:5px;">通院の頻度などの詳細：</p>
          <div v-if="formatData.hospitalVisit == 'あり'" style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.hospitalVisitDescription"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>
          <br />
          <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>得意なこと・スキル：</p>
          <div style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.skillDescription"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>
          <br />
          <p style="font-size: 90%;margin-bottom:5px;">障がい特性：<el-button
              @click="$modal.show('disorderFeatureSample-dialog')" type="success">例文から追加</el-button></p>
          <div style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <modal name="disorderFeatureSample-dialog" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('disorderFeatureSample-dialog');" icon="el-icon-close"
                    type="text"></el-button>
                </div>
                <div class="title">例文を選ぶ</div>
                <div class="description">
                  <p>選択した例文が追加されます。</p>
                  <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
                </div>
                <ul class="example-sentence">
                  <li v-for="(item, idx) in disorderFeatureStatement"
                    v-on:click="formatData.disorderFeature = item.description.replace(/<br>/ig, '\n') + '\n'; $modal.hide('disorderFeatureSample-dialog');"
                    :key="idx">
                    <div class="title">{{ item.title }}</div>
                    <div class="body" v-html="item.description"></div>
                  </li>
                </ul>
                <div class="text-right">
                  <el-button @click="$modal.hide('disorderFeatureSample-dialog')">閉じる</el-button>
                </div>
              </modal>
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.disorderFeature"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>
          <br />
          <p style="font-size: 90%;margin-bottom:5px;">障害特性に対する自己対処：<el-button
              @click="$modal.show('selfDisorderFeatureSample-dialog')" type="success">例文から追加</el-button></p>
          <div style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <modal name="selfDisorderFeatureSample-dialog" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('selfDisorderFeatureSample-dialog');" icon="el-icon-close"
                    type="text"></el-button>
                </div>
                <div class="title">例文を選ぶ</div>
                <div class="description">
                  <p>選択した例文が追加されます。</p>
                  <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
                </div>
                <ul class="example-sentence">
                  <li v-for="(item, idx) in selfDisorderFeatureStatement"
                    v-on:click="formatData.selfDisorderFeature = item.description.replace(/<br>/ig, '\n') + '\n'; $modal.hide('selfDisorderFeatureSample-dialog');"
                    :key="idx">
                    <div class="title">{{ item.title }}</div>
                    <div class="body" v-html="item.description"></div>
                  </li>
                </ul>
                <div class="text-right">
                  <el-button @click="$modal.hide('selfDisorderFeatureSample-dialog')">閉じる</el-button>
                </div>
              </modal>
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.selfDisorderFeature"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>
          <br />
          <p style="font-size: 90%;margin-bottom:5px;">自己対処ではカバーしきれない企業側への配慮希望：<el-button
              @click="$modal.show('considerationDesired-dialog')" type="success">例文から追加</el-button></p>
          <div style="display: inline-block;min-width: 100%;">
            <p style="font-size: 100%;text-align:left;">
              <modal name="considerationDesired-dialog" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('considerationDesired-dialog');" icon="el-icon-close"
                    type="text"></el-button>
                </div>
                <div class="title">例文を選ぶ</div>
                <div class="description">
                  <p>選択した例文が追加されます。</p>
                  <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
                </div>
                <ul class="example-sentence">
                  <li v-for="(item, idx) in considerationDesiredStatement"
                    v-on:click="formatData.considerationDesired = item.description.replace(/<br>/ig, '\n') + '\n'; $modal.hide('considerationDesired-dialog');"
                    :key="idx">
                    <div class="title">{{ item.title }}</div>
                    <div class="body" v-html="item.description"></div>
                  </li>
                </ul>
                <div class="text-right">
                  <el-button @click="$modal.hide('considerationDesired-dialog')">閉じる</el-button>
                </div>
              </modal>
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                v-model="formatData.considerationDesired"></el-input>
            </p>
            <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
            <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
          </div>

        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'recommend'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>推薦・紹介を依頼</h2>
          <p>就労支援施設に障がいの詳細の記載と推薦文作成を依頼しましょう</p>
          <p style="color:red;">※推薦・紹介文が作成されたら、上記のメールアドレスにお知らせいたします。</p>
          <p style="color:red;">※推薦・紹介文を依頼せずにオファーを受けることも可能です。</p>
        </div>
        <div class="card-content">

          <div style="display: inline-block;min-width: 100%;text-align:center;">
            <br />
            <p style="font-size: 120%;font-weight: bold;text-align: left;margin-bottom: 10px;">お願いする相手の情報</p>
            <div style="display: inline-block;min-width: 100%;text-align:center;">
              <p style="font-size: 100%;text-align:left;"> 就労支援事業所または施設名：<br>
                <el-input class="input-md" placeholder="" title="就労支援事業所または施設名" ref="introName"
                  v-model="formatData.introName" type="email"></el-input>
              </p>
            </div>
            <br>
            <div style="display: inline-block;min-width: 100%;text-align:center;">
              <p style="font-size: 100%;text-align:left;"> メールアドレス：<br>
                <el-input class="input-md" placeholder="" title="メールアドレス" ref="introEmail"
                  v-model="formatData.introEmail" type="email"></el-input>
              </p>
            </div>
            <br>
            <div style="display: inline-block;min-width: 100%;text-align:center;">
              <p style="font-size: 100%;text-align:left;"> 関係：<br>
                <el-select v-model="formatData.relationship" placeholder="選択してください">
                  <el-option v-for="item in relationshipOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </p>
            </div>
            <br>
            <div style="display: inline-block;min-width: 100%;text-align:center;">
              <p style="font-size: 100%;text-align:left;">
                <span style="">作成期限は依頼してから２週間後になります。</span>
              </p>
            </div>
            <br>
            <div style="display: inline-block;min-width: 100%;text-align:center;">
              <br>
              <p style="font-size: 100%;text-align:left;"> お願い内容：<el-button @click="$modal.show('requestsample-dialog')"
                  type="success">例文から追加</el-button><br>
                <br>
                <modal name="requestsample-dialog" :adaptive="true" :scrollable="true" height="auto">
                  <div class="v--modal-close-top">
                    <el-button @click="$modal.hide('requestsample-dialog');" icon="el-icon-close"
                      type="text"></el-button>
                  </div>
                  <div class="title">例文を選ぶ</div>
                  <div class="description">
                    <p>選択した例文が追加されます。</p>
                    <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
                  </div>
                  <ul class="example-sentence">
                    <li v-for="(item, index) in exampleRequestSentences.request_statement"
                      v-on:click="formatData.requestStatement += item.replace(/<br>/ig, '\n') + '\n'; $modal.hide('requestsample-dialog');"
                      :key="index">
                      <div class="title">{{ index }}</div>
                      <div class="body" v-html="item"></div>
                    </li>
                  </ul>
                  <div class="text-right">
                    <el-button @click="$modal.hide('requestsample-dialog')">閉じる</el-button>
                  </div>
                </modal>
                <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                  v-model="formatData.requestStatement"></el-input>
              </p>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>履歴書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="選択してください"
                  :format="'yyyy年M月d日'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
          <div class="aiInterview_date" v-if="$globalVar.in_app_payments">
            <!--<p>履歴書を作成したら、面接の準備をしよう！</p>-->
            <a href="/yagiprimequickemail/info" class="aiInterview_lead" target="_blank" id="quickemailbnr_date_btn">
              <img src="/static/mypage/quickemailbnr.jpg" alt="メール便">
            </a>
          </div>
          <div v-if="false">
            <el-collapse accordion v-model="activeName" v-if="formatId != 'rirekisho_esf_challenged'">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">ヤギのオススメ</span>あなたの大切な履歴書を確実にお届け
                  </div>
                </template>
                <div class="el-collapse-item__content" style="padding: 0;">

                  <button data-v-a884de18="" type="button" class="el-button el-button--default"
                    :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" @click="sendQuickmailLP"
                    style="width: 100%;border: 0px; border-radius: 10px;background: rgb(227, 22, 92);color: rgb(227, 22, 92);font-size: 16px;line-height: 1.5; margin-bottom: 20px;"><!----><!---->
                    <span>
                      <h3 data-v-a884de18="" style="color: rgb(255, 255, 255);">Yagishに<br
                          data-v-a884de18="">履歴書を郵送してもらう
                      </h3>
                    </span>
                  </button>
                  <div class="bnr_item create-date_bnr" v-if="false">
                    <div class="bnr_txt create-date_txt">
                      <el-button style="width:100%;border:0px;background: #E3165C;color:#E3165C;font-size: 1.1rem;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" @click="sendQuickmailLP">
                        <h3 style="color:#fff">Yagishに<br>履歴書を郵送してもらう</h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" v-show="false">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">オススメ</span>印刷から郵送まであなたの代わりに！ヤギの宅配便サービス
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <p>就職または転職を考えている企業先に、あなたの代わりにヤギッシュが「履歴書」「送付状」「封筒」を印刷して郵送いたします。（職務経歴書は自由選択）</p>

                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button
                        style="width:100%;border:0px;padding:20px;background: #EFF8F8;color:#E3165C;font-size: 1.1rem;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId);">
                        <h3>ヤギの宅配便<span>をつかう</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" stcyle="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>作成した履歴書を確認</h2>
          <p>修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます</p>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses"
        @update:isSendYagiEmailEnabled="isSendYagiEmailEnabled = $event">
      </download-item>

      <div class="overflow-scroll-y" v-if="false">
        <div class="card-header">
          <h2>ダウンロード</h2>
          <p v-if="false">作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
          <p style="color:red;" v-if="!$firebase.isAuthenticated">
            ※ヤギの宅配便、メール送信、コンビニ印刷、ダウンロードはログインが必須となります。<br>下記のログインフォームでログインしてください。</p>
        </div>
        <div class="card-content">
          <div class="button-download-pdf" v-if="$firebase.isAuthenticated">
            <div class="bnr_container" v-if="formatId == 'internship'" style="padding: 0;">
              <div class="bnr_item">
                <img @click="$eventHub.$emit('send-yagish-intern');"
                  src="/static/renew_img/bnr/intern_yagish_bnr_20230414.png" alt="Yagishインターン">
                <div class="bnr_txt" v-if="!isSendedYagishIntern">
                  <ul style="font-size: 0.8rem; margin-left: 0;text-align: left;">
                    <li>※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。</li>
                    <li>※選考に進む際はこちらからご連絡いたします。</li>
                    <li>※インターンに関する採用情報は<a href="https://www.yagish.jp/recruit-info/intern2023/"
                        target="_blank">こちら</a>からご確認ください。</li>
                  </ul>
                </div>
                <div class="bnr_txt" v-else>
                  <ul style="font-size: 0.8rem; margin-left: 0;">
                    <li>履歴書が送付されました。ありがとございます</li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">
              <div id="quickmail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      <p>履歴書送付は任せろメェ〜</p>
                      <br>
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便" style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="quickemail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                      <p>応募先企業に1クリックで送信</p>
                      <br>
                      <h3>ヤギのメール便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/static/renew_img/quickemail_button.png" alt="ヤギのメール便"
                    style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="combie" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button id="pdf-eprint-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      <p>面接に履歴書が必要？印刷だメェ〜</p>
                      <br>
                      <h3>コンビニプリント<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/static/renew_img/print.png" alt="コンビニプリント" style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      <p>登録したメアドに送るメェ〜</p>
                      <br>
                      <h3>PDFをメールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
                </div>
              </div>
              <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
                </div>
              </div>

              <div id="pdf-download" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                      <p>端末に保存するメェ〜</p>
                      <br>
                      <h3>PDFをダウンロードする</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note">
                    <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                      rel="nofollow">※できない場合はこちら</a>
                  </p>
                </div>
              </div>

            </div>

            <div id="completed-buttons" class="bnr_container" v-else>
              <div id="quickmail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便">
                  <div class="bnr_txt">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      <p>履歴書送付は任せろメェ〜</p>
                      <br>
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="quickemail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/static/renew_img/quickemail_button.png" alt="ヤギのメール便">
                  <div class="bnr_txt">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="handleYagiEmailClick('send-special-quickemail', formatId)">
                      <p>応募先企業に1クリックで送信</p>
                      <br>
                      <h3>ヤギのメール便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="combie" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/static/renew_img/print.png" alt="コンビニプリント">
                  <div class="bnr_txt">
                    <el-button id="pdf-eprint-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      <p>面接に履歴書が必要？印刷だメェ〜</p>
                      <br>
                      <h3>コンビニプリント<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      <p>登録したメアドに送るメェ〜</p>
                      <br>
                      <h3>PDFをメールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
                </div>
              </div>
              <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
                </div>
              </div>

              <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                      <p>端末に保存するメェ〜</p>
                      <br>
                      <h3>PDFをダウンロードする</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note">
                    <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                      rel="nofollow">※できない場合はこちら</a>
                  </p>
                </div>
              </div>

            </div>

          </div>
          <div class="button-download-pdf" v-else>
            <div class="text-center">
              <login-forms />
            </div>
          </div>
        </div>
        <div class="card-content">
          <el-collapse v-model="downloadActiveCollapses">

            <el-collapse-item title="ヤギにはがきを渡す" v-if="false" name="postcard">
              <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                    src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
            </el-collapse-item>

            <el-collapse-item title="スマホから履歴書を印刷するには" name="print">
              <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。
              </div>
              <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
              <ul class="collapse-list" v-if="$firebase.isAuthenticated">
                <li>
                  <a id="pdf-eprint-edit" type="success" style="cursor:pointer;" :disabled="!$deviceLib.isOnline"
                    @click="$eventHub.$emit('show-preview-4conv')">
                    セブンイレブン・ファミリーマート・ローソンなど - eプリント
                  </a>
                </li>
              </ul>
            </el-collapse-item>
            <el-collapse-item title="他の端末から続きを書くには" name="backup">
              <div>
                他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット 2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>
<style scoped>
.r-ai-format {
  border: 2px solid #8FBD67;
  border-radius: 10px;
  margin-top: 10px;
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));
  background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));
  margin-bottom: 10px;
  padding: 15px;
  width: 100%;
}

.r-ai-format .r-midashi {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: bold;
  color: rgb(255, 255, 255);
  background: rgb(15, 153, 52);
  border-radius: 15px;
  padding: 2px 10px;
  margin-bottom: 5px;
}

.r-ai-format .title {
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 700;
}

.r-ai-format .r-form-title {
  margin-top: 10px;
  align-items: center;
}

.r-ai-format .r-form-title span {
  width: 10%;
  font-size: 0.8rem;
  margin-right: 5px;
}

.r-ai-format .r-txtarea {
  min-height: 36px;
  height: 36px;
}

.r-ai-format .r-btn-wrap {
  margin-top: 10px;
}

.r-ai-format .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8FBD67;
  border-color: #8FBD67;
  overflow: hidden;
}

.r-ai-format .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(130deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}

.r-ai-format .example-sentence li:hover {
  background: none;
}
</style>

<style scoped>
.yp-agent-register .card-header {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f8f8f8;
}

.yp-agent-register .yp-h2 {
  margin-bottom: 10px;
}

.yp-agent-register .card-content {
  border-top: none;
}

.yp-agent-register .yp-agent-list {
  margin-top: 20px;
}

.yp-agent-register .agent-logo {
  height: 50px;
  width: auto;
  margin-bottom: 10px;
  margin-right: 10px;
}

.yp-agent-register .agent-txt:last-child {
  margin-bottom: 10px;
}

.yp-agent-register .yp-agent-lead {
  color: #e3165c;
}

.yp-agent-register .yp-agent-memo {
  font-size: 0.75rem;
}

.yp-agent-register .consent-txt {
  align-items: center;
}

.yp-agent-register .consent-icon {
  width: auto;
  height: 16px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 5px;
}

.yp-agent-register .r-btn-wrap {
  margin-top: 10px
}

.yp-agent-register .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8FBD67;
  border-color: #8FBD67;
  overflow: hidden;
}

.yp-agent-register .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(130deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}
</style>

<style scoped>
.custom-modal {
  padding: 0px !important;
}

.ai-payment-card-box {
  display: flex;
  flex-direction: column;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.aiInterview_date {
  text-align: center;
}

.aiInterview_date {
  .aiInterview_lead {
    p {
      font-size: 0.75rem;
    }

    img {
      width: 350px;
      border-radius: 10px;

      @media screen and (max-width: 599px) {
        width: 100%;
      }

    }
  }
}

//tips
.tips {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;

  &__accordion {
    background: #eef5e8;
    border-radius: 6px;
    padding: 5px 10px;
    margin-bottom: 10px;
    font-size: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }

    summary {
      position: relative;
      color: #004D40;
      font-weight: bold;

      &::after {
        position: absolute;
        content: "";
        background-image: url(/static/img/closebtn.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        width: 15px;
        height: 15px;
        right: 0;
      }
    }

    &:not([open]) {
      summary {
        &::after {
          background-image: url(/static/img/openbtn.svg);
          right: -15px;
          top: -5px;
        }
      }
    }
  }
}

.guidetxt {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}

.guideimg {
  display: block;
  width: 70%;
  margin: 0 auto 20px;

  @include max-width(sm) {
    width: 100%;
  }

}

.id-old-txt {
  font-weight: bold;
  text-align: center;
}

.prime-tips-btn-wrap {
  text-align: center;
  margin: 20px 0 10px;
}

.prime-tips-btn {
  display: inline-block;
  background: #FF8C00;
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  border: none;
  border-radius: 30px;
  padding: 10px 24px;
  cursor: pointer;
}

.prime-modal {
  ::v-deep .v--modal-box {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  ::v-deep .v--modal {
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
    width: calc(100% - 40px) !important;
    border-radius: 8px;
    max-width: 400px;
  }
}

.prime-modal-content {
  text-align: center;

  .mypr-title-block {
    margin-bottom: 20px;

    .mypr-title-catch {
      position: relative;
      top: -25px;
      display: inline-block;
      font-weight: bold;
      font-size: 10px;
      color: #ffffff;
      background: #FF8C00;
      padding: 3px 10px;
      border-radius: 30px;
      float: left;
    }

    h3 {
      clear: both;
      color: #004D40;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      line-height: 1.4;
      margin-bottom: 10px;
      margin-top: -10px;
    }
  }

  .prime-modal-lead {
    font-size: 13px;
    line-height: 1.6;
    text-align: center;
  }

  .prime-modal-image {
    width: 100%;
    border-radius: 8px;
    margin: 15px 0;

    img {
      width: 80%;
      border-radius: 8px;
    }
  }

  .prime-modal-note {
    font-size: 10px;
    color: #666;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 20px;
  }

  .prime-modal-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .prime-modal-cv-btn,
    .prime-modal-detail-btn {
      width: 100%;
      max-width: 300px;
      padding: 12px 20px;
      font-size: 14px;
      font-weight: bold;
      border-radius: 6px;
      cursor: pointer;
      line-height: 1.4;
      box-sizing: border-box;
    }

    .prime-modal-cv-btn {
      background: #E3165C;
      color: #ffffff;
      border: none;
    }

    .prime-modal-detail-btn {
      background: #ffffff;
      color: #E3165C;
      border: 1px solid #E3165C;
      text-decoration: none;
      text-align: center;
      display: inline-block;
      box-sizing: border-box;
    }
  }
}
</style>
<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import { loadStripe } from '@stripe/stripe-js'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import City from '@/plugins/tryt-city-master'
import YagiprimeWrapper from '@/components/Payment/YagiprimeWrapper.vue'
import ReasonCard from '../yagiprime/ReasonCard.vue'
import { industryData } from '@/assets/formats/industryData'
import { jobTypeData } from '@/assets/formats/jobTypeData'
import PersonalRequestFields from './RirekishoParts/PersonalRequestFields'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'RirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    StripeElementCard,
    YagiprimeWrapper,
    ReasonCard,
    'personal-request-fields': PersonalRequestFields
  },
  data: function () {
    return {
      industryData,
      jobTypeData,
      isPaymentYagiprime: true,
      completeBuyYagiprime: false,
      fullscreenLoading: false,
      loadingText: 'AIがあなたに最適なテキストを生成しています',
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      matchingCompany: {},
      isMatching: false,
      trytCity: City,
      paymentMethod: 'card',
      paymentMethodTab: 'card',
      isApplePayAvailable: false,
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      viewYagiprimepayment: false,
      hopeIndustryOptions: ['', 'IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions: ['', '営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],

      requestAiGenerated: false,
      requestAiLoading: false,
      requestAiError: '',
      lastAiInputSnapshot: null,
      bizreachIndustries: [],
      bizreachJobCategories: [],
      showRequestEditDialog: false,

      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        lastestEdu: '',
        lastestJob: '',

        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: '',
        requestStatement: '',
        shogaiLevel: '',
        shogaiKind: '',
        handbookKind: '',
        hospitalVisit: '',
        hospitalVisitDescription: '',
        skillDescription: '',
        disorderFeature: '',
        selfDisorderFeature: '',
        considerationDesired: ''
      },
      handbookKindOptions: [
        { value: '身体障害者手帳', label: '身体障害者手帳' },
        { value: '療育手帳', label: '療育手帳' },
        { value: '精神障害者保健福祉手帳', label: '精神障害者保健福祉手帳' }
      ],
      selectAlliancesOptions: [
        { value: '障がい福祉イノベーション', label: '障がい福祉イノベーション' },
        { value: '広告やメディア', label: '広告やメディア' },
        { value: '障がい者から依頼', label: '障がい者から依頼' },
        { value: 'その他', label: 'その他' }
      ],
      disorderFeatureStatement: {
        '特性①': '急ぎの作業の際にケアレスミスが起きやすい',
        '特性②': '過集中傾向があり、話しかけられても気づかない時がある。',
        '特性③': 'マルチタスクが苦手'
      },
      selfDisorderFeatureStatement: {
        '自己対応①': 'Wチェックの徹底を行い、納品時に第三者のチェックをお願いする',
        '自己対応②': '適度な小休憩で過集中を防ぐ',
        '自己対応③': '作業開始前にタスク整理を行い、各作業を時間単位で区切り、マルチタスクに対応する'
      },
      considerationDesiredStatement: {
        '配慮①': '通院配慮：月に1度、第三火曜日に通院のため、午前休を頂ければ幸いです。',
        '配慮②': '過度な残業：残業は月に約5時間以内をお願いできればと思います。',
        '配慮③': '相談環境：業務で悩んだ際に相談しやすい環境があれば幸いです。'
      },
      shogaiKindOptions: [],
      shogaiKindOptionTemps: {
        first: [
          { value: '視覚障害', label: '視覚障害' },
          { value: '聴覚または平衡機能の障害', label: '聴覚または平衡機能の障害' },
          { value: '音声機能', label: '音声機能' },
          { value: '言語機能またはそしゃく機能の障害', label: '言語機能またはそしゃく機能の障害' },
          { value: '肢体不自由（車椅子あり）', label: '肢体不自由（車椅子あり）' },
          { value: '肢体不自由（車椅子なし）', label: '肢体不自由（車椅子なし）' },
          { value: '心臓機能の障害', label: '心臓機能の障害' },
          { value: 'じん臓機能の障害', label: 'じん臓機能の障害' },
          { value: '呼吸器機能の障害', label: '呼吸器機能の障害' },
          { value: 'ぼうこうまたは直腸の機能の障害', label: 'ぼうこうまたは直腸の機能の障害' },
          { value: '小腸の機能の障害', label: '小腸の機能の障害' },
          { value: 'ヒト免疫不全ウイルスによる免疫の機能の障害', label: 'ヒト免疫不全ウイルスによる免疫の機能の障害' },
          { value: '肝臓の機能の障害', label: '肝臓の機能の障害' },
          { value: 'その他', label: 'その他' }
        ],
        second: [
          { value: '知的障害', label: '知的障害' },
          { value: 'その他', label: 'その他' }
        ],
        third: [
          { value: '統合失調症', label: '統合失調症' },
          { value: 'うつ病、双極性障害（躁うつ病）などの気分障害', label: 'うつ病、双極性障害（躁うつ病）などの気分障害' },
          { value: '非定型精神病', label: '非定型精神病' },
          { value: 'てんかん', label: 'てんかん' },
          { value: '中毒精神病', label: '中毒精神病' },
          { value: '高次脳機能障害', label: '高次脳機能障害' },
          { value: '発達障害', label: '発達障害' },
          { value: 'その他の精神疾患など', label: 'その他の精神疾患など' },
          { value: 'その他', label: 'その他' }
        ]
      },
      shogaiLevelOptions: [],
      shogaiLevelOptionTemps: {
        first: [
          { value: '1級', label: '1級' },
          { value: '2級', label: '2級' },
          { value: '3級', label: '3級' },
          { value: '4級', label: '4級' },
          { value: '5級', label: '5級' },
          { value: '6級', label: '6級' },
          { value: '7級', label: '7級' },
          { value: '手帳取得中', label: '手帳取得中' }
        ],
        second: [
          { value: '最重度（A判定）', label: '最重度（A判定）' },
          { value: '重度（A判定）', label: '重度（A判定）' },
          { value: '中度（B判定）', label: '中度（B判定）' },
          { value: '軽度（B判定）', label: '軽度（B判定）' },
          { value: 'それ以外（B判定）', label: 'それ以外（B判定）' },
          { value: '手帳取得中', label: '手帳取得中' }
        ],
        third: [
          { value: '1級', label: '1級' },
          { value: '2級', label: '2級' },
          { value: '3級', label: '3級' },
          { value: '手帳取得中', label: '手帳取得中' }
        ]
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      previewScale: 1,
      previewViewerCss: {},
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
      reasonLabel20240717: '志望動機を入力してください。書き方に迷うときは、「AIで文章作成」ボタンから、AIが志望動機の下書きを自動作成できます。',
      reasonLabel20250126: 'あなたの入力した内容で志望動機を、AIで途中まで作成してみました。\n文章は編集することが可能です。',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      relationshipOptions: [
        {
          value: '就労支援施設職員',
          label: '就労支援施設職員'
        }
        // {
        //   value: '両親・保護者',
        //   label: '両親・保護者'
        // },
        // {
        //   value: '友人・知人',
        //   label: '友人・知人'
        // },
        // {
        //   value: 'その他',
        //   label: 'その他'
        // }
      ],
      exampleRequestSentences: {
        // 志望動機
        request_statement: {
          '': 'お世話になっています。\nこの度は、私の推薦文を書いていただきたいと思っております。\nご多忙の中、恐縮ですがお力添えの程、何卒よろしくお願いいたします。'
        }
      },
      isCampaign: false,
      isCampaign4Me: false,
      trial_campaign_id: 0,
      aiResultView: false
    }
  },

  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    getLicences: function () {
      let licensesStr = ''
      for (const key in this.formatData.licenseHistories) {
        licensesStr = licensesStr + this.formatData.licenseHistories[key].description + ','
      }
      return licensesStr
    },
    bizreachIndustryGroups: function () {
      return this._groupByCategory(this.bizreachIndustries, 'ig_cd', 'i_cd')
    },
    bizreachJobCategoryGroups: function () {
      return this._groupByCategory(this.bizreachJobCategories, 'jg_cd', 'j_cd')
    },
    industryNameMap: function () {
      const map = {}
      this.bizreachIndustries.forEach(function (i) { map[i.i_cd] = i.name })
      return map
    },
    jobCategoryNameMap: function () {
      const map = {}
      this.bizreachJobCategories.forEach(function (j) { map[j.j_cd] = j.name })
      return map
    }
  },
  methods: {
    loading_on: function () {
      this.fullscreenLoading = true
    },
    loading_off: function () {
      this.fullscreenLoading = false
      this.completeBuyYagiprime = true
    },
    viewPaymentYagiprime: function () {
      this.viewYagiprimepayment = true
      this.initializeExpressCheckout()
    },
    paymentYagiprime: function () {
      console.error(this.paymentMethod)
      const app = this
      if (app.isPaymentYagiprime && this.paymentMethod === 'card') {
        this.$refs.stripeCardElememt.submit()
      }
    },
    tokenCreated (token, merchantPaymentId = '') {
      const app = this
      app.fullscreenLoading = true
      app.isPaymentYagiprime = false
      app.$eventHub.$emit('loading_on')
      this.token = ''
      if (token) {
        this.token = token.id
      }
      if (merchantPaymentId) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      if (app.isCampaign) {
        formData.append('trial_campaign_id', app.trial_campaign_id)
      }
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.status === 201) {
            app.completeBuyYagiprime = true
            app.$globalVar.isYagiPrime = true
            const subformData = new FormData()
            subformData.append('route', 'rirekisho_ai_career')
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            formData.append('current_location', app.getPrefName(app.basicData.address1))
            formData.append('preferred_job', app.formatData.hopeJobcategory)
            formData.append('app_flag', app.$site.appFlag)
            formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('version', '3')
            formData.append('site_flag', 'r')
            formData.append('age', app.basicData.age)
            formData.append('applicant_type_id', '2')
            app.$axios
              .post(app.$varuna.endPoints.primeAdditionalInfo, formData, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                if (response.data.success) {
                  app.matchingCompany = response.data.matching_company
                  app.isMatching = response.data.is_matching
                }
              })
              .catch(function () {
              }).finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    yagiprimePaypay: function (param) {
      const app = this
      app.fullscreenLoading = true

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      const routeId = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        formData.append('route', routeId)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)

      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url)
          location.href = response.data.authorization_url
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    getPrefName: function (address) {
      for (const key in this.trytCity.prefs) {
        if (address && address.indexOf(this.trytCity.prefs[key]) >= 0) {
          return this.trytCity.prefs[key]
        }
      }
      return ''
    },
    async initializeExpressCheckout () {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = 550
      const CURRENCY = 'jpy'
      const LABEL = 'ヤギプライム'

      // Apple Pay の paymentRequest を作成または取得
      if (!this.paymentRequest) {
        this.paymentRequest = stripe.paymentRequest({
          country: 'JP',
          currency: CURRENCY,
          total: {
            label: LABEL,
            amount: AMOUNT
          },
          requestPayerName: true,
          requestPayerEmail: true
        })

        // Apple Pay が利用可能か確認
        const result = await this.paymentRequest.canMakePayment()
        console.log('Apple Pay 利用可能:', result)
        this.isApplePayAvailable = !!(result && result.applePay)
      }
    },
    async mountExpressCheckoutElement () {
      await this.$nextTick() // DOMが更新されるのを待つ
      if (!this.expressCheckoutElement) {
        this.loadingText = ''
        this.fullscreenLoading = true
        const stripe = await loadStripe(this.publishableKey)
        const AMOUNT = 550
        const CURRENCY = 'jpy'
        const LABEL = 'ヤギプライム'
        const elements = stripe.elements({
          mode: 'subscription',
          amount: AMOUNT,
          currency: CURRENCY
        })

        console.log('Customerの作成開始')
        const customerForm = new FormData()
        customerForm.append('uuid', this.$firebase.user.uid)
        customerForm.append('subscription_type', 1)
        const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
        if (routeId) {
          customerForm.append('route', routeId)
        } else {
          customerForm.append('route', '')
        }

        const response = await this.$axios.post(this.$varuna.endPoints.createStripeCustomer, customerForm)

        console.log('Customerの作成成功:', response.data.success)
        console.log('IncompleteSubscriptionの作成成功:', response.data.client_secret)

        this.clientSecret = response.data.client_secret

        this.expressCheckoutElement = elements.create('expressCheckout', {
          paymentRequest: this.paymentRequest
        })

        this.expressCheckoutElement.mount('#payment-request-button')
        this.fullscreenLoading = false

        this.expressCheckoutElement.on('click', (e) => {
          const options = {
            clientSecret: this.clientSecret,
            applePay: {
              recurringPaymentRequest: {
                paymentDescription: LABEL,
                regularBilling: {
                  amount: AMOUNT,
                  label: LABEL,
                  recurringPaymentIntervalUnit: 'day',
                  recurringPaymentIntervalCount: 30
                },
                billingAgreement:
                  '30日間ごとに550円(税込)となります。\n本サービスにお申込みいただき、お客様の登録が完了した時点でご利用代金が引き落とされると同時に、サービスが開始されます。\n初回のサービス提供期間終了後、自動更新され、お客様の選択により、以降30日間ごとに550円（税込）がかかります。\n利用代金は更新されたサービス期間の毎初日に登録された決済情報から引き落とされます。\nお申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。',
                managementURL: 'https://rirekisho.yagish.jp/mypage/account'
              }
            }
          }
          e.resolve(options)
        })

        this.expressCheckoutElement.on('confirm', async (event) => {
          try {
            console.log('フォームのデータを送信開始')
            const { error: submitError } = await elements.submit()
            if (submitError) {
              console.error('フォーム送信エラー:', submitError)
              this.$message({
                message: submitError.message,
                type: 'error'
              })
              event.complete('fail')
              return
            }
            console.log('PaymentIntentの確認開始')
            const { error: confirmError } = await stripe.confirmPayment({
              elements,
              clientSecret: this.clientSecret,
              confirmParams: {
                return_url: window.location.href
              }
            })
            console.log(confirmError)
          } catch (error) {
            console.error('支払いエラー:', error)
            this.$message({
              message: '支払いに失敗しました。',
              type: 'error'
            })
            event.complete('fail')
          }
        })
      }
    },
    getAIMypr: function () {
      const app = this
      // console.error(app.formatData.educationalHistories.length)
      // console.error(app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // return
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      formData.append('education', app.formatData.lastestEdu)
      formData.append('job', app.formatData.lastestJob)
      formData.append('licenses', app.getLicences)
      formData.append('strength', app.formatData.ai_strength)
      formData.append('company_name', app.formatData.ai_company_name)
      formData.append('company_industry', app.formatData.hopeIndustrycategory)
      formData.append('company_job', app.formatData.hopeJobcategory)

      this.$axios
        .post(this.$varuna.endPoints.aiIntroducePr, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.success)
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message === 'AIの使用回数が上限に達しました。') {
            app.aiResultView = true
          }
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduceReason, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.success) {
            app.aiResultReasonResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    getAIMyprX: function () {
      const app = this
      // console.error(app.formatData.educationalHistories.length)
      // console.error(app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // return
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      if (app.formatData.educationalHistories.length > 0) {
        formData.append('education', app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      } else {
        formData.append('education', '')
      }
      formData.append('strength', this.formatData.ai_mypr_good)
      formData.append('weakness', this.formatData.ai_mypr_bad)
      formData.append('hobby', this.formatData.ai_mypr_hobby)
      formData.append('future', this.formatData.ai_mypr_wanted)
      formData.append('free', this.formatData.ai_mypr_appeal)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduce, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.success)
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applyAgent: function () {
      const app = this
      const isCheck = true

      if (isCheck) {
        app.fullscreenLoading = true

        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        if (this.matchingCompany) {
          formData.append('company_uid', this.matchingCompany.company_uid)
          formData.append('category', this.matchingCompany.category)
        }
        formData.append('is_matching', this.isMatching)

        // eslint-disable-next-line no-constant-condition
        if (true) {
          formData.append('applicant_type_id', 2)
          formData.append('app_flag', this.$site.appFlag)
          formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
          formData.append('version', '3')
          formData.append('site_flag', 'r')
          this.$axios
            .post(this.$varuna.endPoints.applyAgent, formData, { timeout: 60000 })
            .then(function (response) {
              console.error(response.data)
              if (response.data.success) {
                app.$message({
                  message: '更新完了しました',
                  type: 'success'
                })
                // app.goCardTo('complete')
                app.viewYagiprimepayment = true
                app.$eventHub.$emit('go-card-to', 'output')
              }
            })
            .catch(function () {
              app.$message({
                message: '更新失敗しました',
                type: 'error'
              })
            }).finally(function () {
              app.fullscreenLoading = false
            })
        }
      }
    },
    selectHandbookKind: function () {
      if (this.formatData.handbookKind === '身体障害者手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.first
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.first
      }
      if (this.formatData.handbookKind === '療育手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.second
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.second
      }
      if (this.formatData.handbookKind === '精神障害者保健福祉手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.third
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.third
      }
      this.formatData.shogaiKind = ''
      this.formatData.shogaiLevel = ''
    },
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (const key in historyList) {
        const item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      const tArea = this.$refs.yourTextarea
      const startPos = tArea.selectionStart
      const endPos = tArea.selectionEnd
      const tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      console.error(historyList)
      if (historyList == null) {
        // eslint-disable-next-line no-array-constructor
        historyList = []
      }
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    updateLastestEduFromHistories: function () {
      if (!this.formatData || !this.formatData.educationalHistories || this.formatData.educationalHistories.length === 0) {
        this.formatData.lastestEdu = ''
        return
      }
      const sorted = this.sortHistory(this.formatData.educationalHistories)
      const valid = sorted.filter(function (item) {
        const year = Number(item.year)
        const month = Number(item.month)
        return year && month
      })
      const latest = valid.length > 0 ? valid[valid.length - 1] : null
      this.formatData.lastestEdu = latest && latest.description ? latest.description : ''
    },
    updateLastestJobFromHistories: function () {
      if (!this.formatData || !this.formatData.jobHistories || this.formatData.jobHistories.length === 0) {
        this.formatData.lastestJob = ''
        return
      }
      const sorted = this.sortHistory(this.formatData.jobHistories)
      const valid = sorted.filter(function (item) {
        const year = Number(item.year)
        const month = Number(item.month)
        return year && month
      })
      const latest = valid.length > 0 ? valid[valid.length - 1] : null
      this.formatData.lastestJob = latest && latest.description ? latest.description : ''
    },

    addEducationalHistory: function (index, columns) {
      if (this.formatData.educationalHistories == null) {
        this.$set(this.formatData, 'educationalHistories', [])
      }
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      if (this.formatData.jobHistories == null) {
        this.$set(this.formatData, 'jobHistories', [])
      }
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      if (this.formatData.licenseHistories == null) {
        this.$set(this.formatData, 'licenseHistories', [])
      }
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    sendQuickmailLP: function () {
      location.href = '/quickmail/info'
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    handleYagiprimeRecommend: function () {
      // useFeatureを使ってログインチェックを含めた課金フローを開始
      this.$yagiprimePaymentService.useFeature(this, 'prime-recommend', {
        onSuccess: () => {
          // モーダル閉じる
          this.$modal.hide('prime-photo-modal')
        },
        onCancel: () => {
        }
      })
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    authStateChanged: async function () {
      // 非ログイン時は処理をスキップ
      if (!this.$firebase || !this.$firebase.user) {
        return
      }
      const app = this
      if (app.$firebase.user && app.$firebase.isAuthenticated) {
        app.fullscreenLoading = true
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        this.$axios
          .post(this.$varuna.endPoints.canUseTrialCampaign, formData, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data.can_use_trial_campaign)
            if (response.data.can_use_trial_campaign) {
              app.isCampaign4Me = true
            } else {
              app.isCampaign4Me = false
              app.isCampaign = false
              app.trial_campaign_id = null
            }
          })
          .catch(function () {
          }).finally(function () {
            app.fullscreenLoading = false
          })
      }
    },
    changeLoadingText: function (text) {
      this.loadingText = text
    },
    // ヤギメール送信ボタンクリック時の処理
    handleYagiEmailClick: function (eventName, formatId) {
      // 状態を無効化
      this.isSendYagiEmailEnabled = false
      // イベントを発火
      this.$eventHub.$emit(eventName, formatId)
    },
    _groupByCategory: function (items, groupKey, codeKey) {
      const groups = {}
      items.forEach(function (item) {
        const gk = item[groupKey]
        if (!groups[gk]) {
          groups[gk] = { label: item.category_name, options: [] }
          groups[gk][groupKey] = gk
        }
        groups[gk].options.push({ value: item[codeKey], label: item.name })
      })
      return Object.values(groups)
    },
    getIndustryName: function (cd) {
      if (!cd) return ''
      return this.industryNameMap[cd] || cd
    },
    getJobCategoryName: function (cd) {
      if (!cd) return ''
      return this.jobCategoryNameMap[cd] || cd
    },
    fetchBizreachMasters: function () {
      const app = this
      return this.$axios
        .post(this.$varuna.endPoints.bizreachMasters, {}, { timeout: 30000 })
        .then(function (response) {
          if (response.data.success) {
            app.bizreachIndustries = response.data.industries
            app.bizreachJobCategories = response.data.jobCategories
          }
        })
        .catch(function (error) {
          console.warn('Failed to fetch bizreach masters:', error)
        })
    },
    buildAiInputSnapshot: function () {
      return JSON.stringify({
        jobHistories: this.formatData.jobHistories,
        licenseHistories: this.formatData.licenseHistories,
        reason: this.formatData.reason,
        ai_company_name: this.formatData.ai_company_name
      })
    },
    restoreRequestAiState: function () {
      if ((this.basicData.yakushokuBusho ||
           this.basicData.gyoushuCd ||
           this.basicData.shokushuCd ||
           this.basicData.kibouGyoushuCd ||
           this.basicData.kibouShokushuCd)) {
        this.requestAiGenerated = true
        this.lastAiInputSnapshot = this.buildAiInputSnapshot()
        if (this.bizreachIndustries.length === 0) {
          this.fetchBizreachMasters()
        }
      }
    },
    getAIAutoRequest: function () {
      const app = this
      app.requestAiLoading = true
      app.requestAiError = ''
      const postData = {
        uuid: app.$firebase.isAuthenticated ? app.$firebase.user.uid : '',
        jobHistories: app.formatData.jobHistories,
        licenseHistories: app.formatData.licenseHistories,
        reason: app.formatData.reason,
        nowNensyu: app.formatData.nowNensyu,
        kibouNensyu: app.formatData.kibouNensyu,
        ai_company_name: app.formatData.ai_company_name || '',
        birthYear: app.basicData.birthYear || ''
      }
      this.$axios
        .post(this.$varuna.endPoints.aiAutoRequest, postData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.success) {
            app.basicData.yakushokuBusho = response.data.yakushoku || ''
            app.basicData.gyoushuCd = response.data.industry_cd || ''
            app.basicData.shokushuCd = response.data.job_category_cd || ''
            app.basicData.kibouGyoushuCd = response.data.hope_industry_cd || ''
            app.basicData.kibouShokushuCd = response.data.hope_job_category_cd || ''
            if (response.data.now_nensyu) {
              app.formatData.nowNensyu = response.data.now_nensyu
            }
            app.requestAiGenerated = true
            app.lastAiInputSnapshot = app.buildAiInputSnapshot()
          } else {
            app.requestAiError = response.data.message || 'AI自動入力に失敗しました。'
          }
        })
        .catch(function (error) {
          app.requestAiError = (error.response && error.response.data && error.response.data.message) || 'AI自動入力でエラーが発生しました。'
        })
        .finally(function () {
          app.requestAiLoading = false
        })
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy年 m月 d日')
    },
    paymentMethodTab: function (val) {
      if (val === 'applepay') {
        this.mountExpressCheckoutElement()
      } else {
        this.expressCheckoutElement.unmount()
        this.expressCheckoutElement = null
      }
    },
    'formatData.educationalHistories': {
      handler () {
        this.updateLastestEduFromHistories()
      },
      deep: true,
      immediate: true
    },
    'formatData.jobHistories': {
      handler () {
        this.updateLastestJobFromHistories()
      },
      deep: true,
      immediate: true
    },
    currentCardId: function (newVal) {
      if (newVal === 'requests') {
        const app = this
        const runAi = function () {
          const currentSnapshot = app.buildAiInputSnapshot()
          if (app.lastAiInputSnapshot === null || app.lastAiInputSnapshot !== currentSnapshot) {
            app.getAIAutoRequest()
          }
        }
        // Fetch masters first, then run AI
        if (this.bizreachIndustries.length === 0) {
          this.fetchBizreachMasters().then(runAi)
        } else {
          runAi()
        }
      }
    }
  },
  created: function () {
    const app = this

    this.$axios
      .get(this.$varuna.endPoints.getTrialCampaign, null, { timeout: 60000 })
      .then(function (response) {
        console.error(app.isCampaign)
        console.error(response.data[0])
        const today = new Date() // 本日の日付
        const startDate = new Date(response.data[0].trial_campaign_start_date)
        const endDate = new Date(response.data[0].trial_campaign_end_date)

        // キャンペーンが有効かつ、本日がキャンペーン期間内かを確認
        if (response.data[0].trial_campaign_is_active && today >= startDate && today <= endDate) {
          app.isCampaign = true
          app.trial_campaign_id = response.data[0].trial_campaign_id
        }
        console.error(app.isCampaign)
      })
      .catch(function () {
      }).finally(function () {
        app.fullscreenLoading = false
      })

    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode !== 'production') {
      this.isWeekEndFlag = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
    }
    this.$eventHub.$on('local-format-data-loaded', this.restoreRequestAiState)
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
    this.$eventHub.$on('loading_on', this.loading_on)
    this.$eventHub.$on('loading_off', this.loading_off)
    this.$eventHub.$on('change-loading-text', this.changeLoadingText)
  },
  destroyed: function () {
    this.$eventHub.$off('local-format-data-loaded', this.restoreRequestAiState)
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
    this.$eventHub.$off('loading_on', this.loading_on)
    this.$eventHub.$off('loading_off', this.loading_off)
    this.$eventHub.$off('change-loading-text', this.changeLoadingText)
  }
}
</script>
